import { Edit, Visibility } from "@mui/icons-material";
import {
    Alert,
    Button,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TablePagination,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { useEffect, useState } from "react";
import {
    getAllLeads,
    SearchOnLeadsAction,
    reset,
} from "../../Redux/LeadsSlice/LeadsSlice";
import { AvaterController } from "../../Layouts/AvaterController";
import { saveObj } from "../../Redux/SaveObjToUpdate/SaveSlice";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

const AllLeads = () => {
    const { user_id } = useParams();
    const dispatch = useDispatch();
    const { leads, search, isLodaing } = useSelector((state) => state.leads);
    const DataTable = leads?.data?.data || [];
    const LeadsPaginate = leads?.data || [];

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    // Filter By Fields Variables
    const [userID, setUserId] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [phone, setPhone] = useState("");
    const [is_active, setIsactive] = useState("");
    const [street, setStreet] = useState("");
    const [status, setStatus] = useState("");
    const [solutions, setSolutions] = useState("");
    const [contracts, setContracts] = useState("");

    const searchObj = {
        user_id,
        name,
        email,
        phone,
        mobile,
        solutions,
        contracts,
        is_active,
        status,
        street,
    };

    const handelFilterAction = async (object_search = null) => {
        await dispatch(
            SearchOnLeadsAction({ ...object_search, paginate: rowsPerPage })
        );
        await dispatch(reset());
    };

    const handelResetData = () => {
        setName("");
        setEmail("");
        setSolutions("");
        setContracts("");
        setIsactive("");
        handelFilterAction();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);

        const callSearchAction = async () => {
            await dispatch(
                SearchOnLeadsAction({
                    ...searchObj,
                    paginate: rowsPerPage,
                    page: newPage + 1,
                })
            );
            await dispatch(reset());
        };
        callSearchAction();
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
        const callSearchAction = async () => {
            await dispatch(
                SearchOnLeadsAction({
                    ...searchObj,
                    paginate: event.target.value,
                })
            );
            await dispatch(reset());
        };
        callSearchAction();
    };

    function inputKeyUp(e) {
        e.which = e.which || e.keyCode;
        if (e.which == 13) {
            //Key code of Enter
            handelFilterAction(searchObj);
        }
    }

    const saved = useSelector((state) => state.save);

    useEffect(() => {
        const GetAllUsers = async () => {
            await dispatch(getAllLeads({ user_id: user_id }));
            user_id ? setUserId(user_id) : setUserId("");
            await dispatch(reset());
        };
        GetAllUsers();
    }, [dispatch, user_id]);

    return (
        <>
            {isLodaing && <LoadingAnimation />}
            {!isLodaing && (
                <TableContainerStyled component={Paper}>
                    <Table aria-label="simple table">
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell style={{ padding: "5px" }}>
                                    Filter By :
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="Parent name"
                                            name="Parent name"
                                            label="Parent Name"
                                            value={name}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setName(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="name"
                                            name="name"
                                            label="Name"
                                            value={name}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setName(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="email"
                                            name="email"
                                            label="Email"
                                            value={email}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setEmail(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="mobile"
                                            name="mobile"
                                            label="Mobile"
                                            value={mobile}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setMobile(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="phone"
                                            name="phone"
                                            label="Phone"
                                            value={phone}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setPhone(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">
                                                Active
                                            </InputLabel>
                                            <Select
                                                id="is_active"
                                                name="is_active"
                                                label="Active"
                                                value={is_active}
                                                onChange={(e) =>
                                                    setIsactive(e.target.value)
                                                }
                                            >
                                                <MenuItem value="2">
                                                    Inactive
                                                </MenuItem>
                                                <MenuItem value="1">
                                                    Active
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="street"
                                            name="street"
                                            label="Street"
                                            value={street}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setStreet(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="status"
                                            name="status"
                                            label="Status"
                                            value={status}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setStatus(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>

                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="solutions"
                                            name="solutions"
                                            label="Solutions"
                                            value={solutions}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setSolutions(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>

                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="contracts"
                                            name="contracts"
                                            label="Contracts"
                                            value={contracts}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setContracts(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>

                                <TableCell
                                    style={{ padding: "5px" }}
                                    align="center"
                                >
                                    <Grid container coulmns={12}>
                                        <Button
                                            style={{ marginBottom: "5px" }}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={(e) =>
                                                handelFilterAction(searchObj)
                                            }
                                        >
                                            <FilterAltIcon></FilterAltIcon>
                                        </Button>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="error"
                                            onClick={(e) => handelResetData()}
                                        >
                                            <RestartAltIcon></RestartAltIcon>
                                        </Button>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        </TableHeadStyled>
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell>#</TableCell>{" "}
                                <TableCell width={200}> Parent Name </TableCell>
                                <TableCell width={200}>Name </TableCell>
                                <TableCell width={250}>Email</TableCell>
                                <TableCell>mobile</TableCell>
                                <TableCell>phone</TableCell>
                                <TableCell>Active</TableCell>
                                {/* <TableCell>location</TableCell> */}
                                <TableCell>street</TableCell>
                                <TableCell>status</TableCell>
                                <TableCell align="center">Solutions</TableCell>
                                <TableCell align="center">Contract</TableCell>
                                <TableCell align="center">ACTIONS </TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableBody>
                            {DataTable.map((key, index) => (
                                <TableRowStyled key={key?.id}>
                                    <TableCellStyle>
                                        {rowsPerPage * page + index + 1}
                                    </TableCellStyle>

                                    <TableCellStyle>
                                        <Link
                                            to={`/dashboard/leads/user=${key?.user?.id}`}
                                        >
                                            <Typography
                                                variant="span"
                                                color="primary"
                                            >
                                                {key?.user?.name}
                                            </Typography>
                                        </Link>
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key.first_name} {key.last_name}
                                    </TableCellStyle>
                                    <TableCellStyle>{key.email}</TableCellStyle>
                                    <TableCellStyle>
                                        {key.mobile}
                                    </TableCellStyle>
                                    <TableCellStyle>{key.phone}</TableCellStyle>
                                    <TableCellStyle>
                                        {key.is_active}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key.street}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key.status}
                                    </TableCellStyle>
                                    <TableCellStyle align="center">
                                        <Link
                                            to={`/dashboard/solutions/lead=${key?.id}`}
                                        >
                                            <IconButton>
                                                <AvaterController
                                                    width="35px"
                                                    height="35px"
                                                    // bg="#288bf4"
                                                    fz="14px"
                                                >
                                                    {key.opportunities_count}
                                                </AvaterController>
                                            </IconButton>
                                        </Link>
                                    </TableCellStyle>
                                    <TableCellStyle align="center">
                                        <Link
                                            to={`/dashboard/solar-contracts/lead=${key?.id}`}
                                        >
                                            <IconButton>
                                                <AvaterController
                                                    width="35px"
                                                    height="35px"
                                                    // bg="#0b1042"
                                                    fz="14px"
                                                >
                                                    {key.solar_contracts_count}
                                                </AvaterController>
                                            </IconButton>
                                        </Link>
                                    </TableCellStyle>

                                    <TableCellStyle align="center">
                                        <IconButton>
                                            <Link
                                                to={`/dashboard/leads/${key.id}`}
                                            >
                                                <Visibility color="primary" />
                                            </Link>
                                        </IconButton>
                                        <IconButton>
                                            <Link
                                                to={`/dashboard/leads/edit=${key.id}`}
                                            >
                                                <Edit color="primary" />
                                            </Link>
                                        </IconButton>
                                    </TableCellStyle>
                                </TableRowStyled>
                            ))}
                        </TableBody>

                        {/* rowsPerPageOptions={[
								LeadsPaginate.to,
								LeadsPaginate.to * 2,
								LeadsPaginate.to * 4,
								LeadsPaginate.to * 10,
								{ label: 'All', value: -1 },
							]} */}

                        <TableHeadStyled>
                            <TableRow>
                                {LeadsPaginate.total >= 20 && (
                                    <TablePagination
                                        rowsPerPageOptions={[
                                            20,
                                            50,
                                            100,
                                            { label: "All", value: -1 },
                                        ]}
                                        colSpan={12}
                                        count={LeadsPaginate.total}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={
                                            handleChangeRowsPerPage
                                        }
                                    />
                                )}
                            </TableRow>
                        </TableHeadStyled>
                    </Table>

                    {LeadsPaginate.total < 1 && (
                        <Alert icon={false} severity="error">
                            <Typography
                                variant="h6"
                                className="MuiTypography-alignCenter"
                            >
                                There are no items, please try again
                            </Typography>
                        </Alert>
                    )}
                </TableContainerStyled>
            )}
        </>
    );
};

export default AllLeads;
